module.exports = __webpack_public_path__ + "img/earth.e6d88ce4.png";